import React from 'react';
import { connect } from 'react-redux';

import Template from './../../templates/UpdateComplete';

const mapStateToProps = state => ({
  currentTheme: state.common.theme,
});
const mapDispatchToProps = {
  //action: operation,
};

class App extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "入退所情報更新完了";
  }
  render() {
    return (
      <Template {...this.props} />
    );
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
export default ContainerApp;
